import React, { memo } from 'react';
import styles from './ChartHeader.scss';
import ChartButton from '../ChartButton';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import IconQuestion from '@dealroadshow/uikit/core/components/Icon/IconQuestion';
import { Periods } from '@/finsight/ui/common/constants';

interface IProps {
  showVolume: boolean,
  showStackedData: boolean,
  disabledVolumeButton: boolean,
  period: string,
  showChartDataByDealSize: () => void,
  showChartDataByDealCount: () => void,
  setRenderByMonth: () => void,
  setRenderByQuarter: () => void,
  setRenderByYear: () => void,
  setShowStackedData: () => void,
  setShowGroupedData: () => void,
}

const ChartHeader = (props: IProps) => (
  <div className={ styles.issueChartHeaderContainer }>
    <div className={ styles.issueChartTitle }>
      <h3>New Issue { props.showVolume ? 'Volume' : 'Deal Count' }</h3>
      <div className={ styles.questionIcon }>
        <Tooltip content="This chart displays new issue volume or deal count. The totals exclude bonds that are retained by the issuer or sponsor.">
          <IconQuestion
            className={ styles.questionFill }
          />
        </Tooltip>
      </div>
    </div>
    <div className={ styles.issueChartButtonsContainer }>
      <div className={ styles.issueChartButtons }>
        <ChartButton
          onClick={ props.showChartDataByDealSize }
          className={ styles.leftBorder }
          value="Volume"
          disabled={ props.showVolume || props.disabledVolumeButton }
          isActive={ props.showVolume }
        />
        <ChartButton
          onClick={ props.showChartDataByDealCount }
          value="Count"
          className={ styles.rightBorder }
          disabled={ !props.showVolume }
          isActive={ !props.showVolume }
        />
      </div>
      <div className={ styles.issueChartButtons }>
        <ChartButton
          onClick={ props.setRenderByMonth }
          className={ styles.leftBorder }
          value="Month"
          disabled={ props.period === Periods.MONTH }
          isActive={ props.period === Periods.MONTH }
        />
        <ChartButton
          onClick={ props.setRenderByQuarter }
          value="Quarter"
          disabled={ props.period === Periods.QUARTER }
          isActive={ props.period === Periods.QUARTER }
        />
        <ChartButton
          onClick={ props.setRenderByYear }
          className={ styles.rightBorder }
          value="Year"
          disabled={ props.period === Periods.YEAR }
          isActive={ props.period === Periods.YEAR }
        />
      </div>
      <div className={ styles.issueChartButtons }>
        <ChartButton
          onClick={ props.setShowStackedData }
          value="Stacked"
          className={ styles.leftBorder }
          disabled={ props.showStackedData }
          isActive={ props.showStackedData }
        />
        <ChartButton
          onClick={ props.setShowGroupedData }
          value="Grouped"
          className={ styles.rightBorder }
          disabled={ !props.showStackedData }
          isActive={ !props.showStackedData }
        />
      </div>
    </div>
  </div>
);

export default memo(ChartHeader);
